interface PartyStatesMap {
  arrived: 'ARRIVED';
  partiallyarrived: 'PARTIALLY_ARRIVED';
  expected: 'EXPECTED';
  partiallyseated: 'PARTIALLY_SEATED';
  seated: 'SEATED';
  left: 'LEFT';
  noshow: 'NO_SHOW';
  canceled: 'CANCELED';
}

const PartyStates: PartyStatesMap = {
  // Ordered by meal progression
  arrived: 'ARRIVED',
  partiallyarrived: 'PARTIALLY_ARRIVED',
  expected: 'EXPECTED',
  partiallyseated: 'PARTIALLY_SEATED',
  seated: 'SEATED',
  left: 'LEFT',
  noshow: 'NO_SHOW',
  canceled: 'CANCELED',
};

export default PartyStates;
